import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import { useIntl, FormattedMessage } from "react-intl";
import GradeCard from "../../components/GradeCard";
import * as criteriaService from "../../../services/Criteria";
// Material-UI
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  makeStyles,
  Typography,
  CircularProgress,
  Backdrop,
  DialogActions,
  Button,
  Box,
} from "@material-ui/core";
import { gradeItems, gradesData, AccordionId } from "../../utils/constants";

import { KeyboardArrowDown } from "@material-ui/icons"
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import {Tabs, Tab} from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "15% 15% 15% 15%",
    // gridTemplateRows: "200px 200px",
    justifyContent: "center",
    // alignItems: "center",
    marginBottom: 10,
    gridColumnGap: "6%",
    width: "-webkit-fill-available",
    height: "100%",
  },
  card :{
    width: "80%",
    margin: "0 auto"
  },
  ul: {
    listStyleType: "disclosure-closed",
    "& li": {
      // fontWeight: 700,
      borderRadius: "30px 0 30px 0",
      letterSpacing: "3px",
      marginBottom: "10px",
      // boxShadow: "0 3px 6px 3px rgb(58 9 78 / 16%)"
    }
  },
  tabPanel: {
    marginTop: "20px",
    border: "5px solid #f3f0fd",
    borderRadius: "10px",
  },
  card: {
    display: "flex",
    flexDirection: "column",
    height: "565px",
    justifyContent: "center",
  }
}));

const Home = () => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const intl = useIntl();
  // Redux
  const { currentStakeholder } = useSelector((state) => state.stakeholder);
  const { person } = useSelector((state) => state.login);
  // Hooks
  const [cardDetails, setCardDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalState, setModalState] = useState(false);
  const [selectedGradeProsDesc, setSelectedGradeProsDesc] = useState("no_desc");
  const [value, setValue] = React.useState(!currentStakeholder?.active && null);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    (async function init() {
      try {
        setLoading(true);
        // const cardDetails = await criteriaService
        //     .getGradeCardDetails(currentStakeholder.industryCategory._id, currentStakeholder.industryCategory._id);
        const cardDetails = gradesData;
        setCardDetails(gradesData.data);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        console.log("error: ", err);
        enqueueSnackbar(
          intl.formatMessage({
            id: err?.response?.data.message || err.message,
          }),
          { variant: "error" }
        );
      }
    })();
  }, []);

  const onClickToGrade = (c) => {
    if (gradeItems.length > 0) {
      gradeItems.forEach((grade) => {
        if (grade.degree === c.grade) {
          setSelectedGradeProsDesc(grade);
          setModalState(true);
        }
      });
    }

    // const prosDesc = c.prosDesc[c.grade];
    // setSelectedGradeProsDesc(prosDesc);
    // setModalState(true);
  };

  return (
    <div className="col-sm-12">
      <Backdrop open={loading} className={classes.backdrop}>
        <CircularProgress color="secondary" />
      </Backdrop>
      {!loading && (
        <div
          className={`card card-custom p-2 flex-row row ${classes.card}`}
          style={{ minHeight: "35rem", padding: "30px 0" }}
        >
          <div className="text-center col-md-12 col-sm-12 d-flex align-items-center" style={{ paddingBottom: "68px" }}>
            <div>
              <Typography component="div" variant="h6">
                {
                  currentStakeholder?.brandName ? `${currentStakeholder?.brandName}, ` :
                    `${person.name} ${person.surname}, `
                }
                <FormattedMessage id="waiting_room.welcome_message" />
              </Typography>
              <Typography component="div" variant="body1" className="mt-4" style={{ width: "70%", margin: "0 auto" }}>
                <FormattedMessage id="waiting_room.welcome_content" />
              </Typography>
              <div>
                
                {/* <Box sx={{ width: '100%', typography: 'body1', height: "200px", marginTop: "20px" }}>
                  <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', display: "flex", justifyContent: "center" }}>
                      <TabList  onChange={handleChange} aria-label="lab API tabs example">
                          <Tab label={intl.formatMessage({ id: "key_grade_level_A+" })} value="1" />
                          <Tab label={intl.formatMessage({ id: "key_grade_level_A" })}  value="1" />
                          <Tab label={intl.formatMessage({ id: "key_grade_level_B" })} value="2" />
                          <Tab label={intl.formatMessage({ id: "key_grade_level_C" })} value="3" />
                      </TabList>
                    </Box>
                    <TabPanel value="1" className={classes.tabPanel}>
                    <ul className={classes.ul}>
                      <li><FormattedMessage id={"key_grade_A_option_1"}/>,</li>
                      <li><FormattedMessage id={"key_grade_A_option_2"}/>,</li>
                      <li><FormattedMessage id={"key_grade_A_option_3"}/>,</li>
                      <li><FormattedMessage id={"key_grade_A_option_4"}/>,</li>
                    </ul>
                  </TabPanel>
                  <TabPanel value="2" className={classes.tabPanel}>
                  <ul className={classes.ul}>
                      <li><FormattedMessage id={"key_grade_B_option_1"}/>,</li>
                      <li><FormattedMessage id={"key_grade_B_option_2"}/>,</li>
                      <li><FormattedMessage id={"key_grade_B_option_3"}/>,</li>
                      <li><FormattedMessage id={"key_grade_B_option_4"}/>,</li>
                      <li><FormattedMessage id={"key_grade_B_option_5"}/>,</li>
                    </ul>
                  </TabPanel>
                  <TabPanel value="3"  className={classes.tabPanel}>
                  <ul className={classes.ul}>
                      <li><FormattedMessage id={"key_grade_C_option_1"}/>,</li>
                      <li><FormattedMessage id={"key_grade_C_option_2"}/>,</li>
                      <li><FormattedMessage id={"key_grade_C_option_3"}/>,</li>
                      <li><FormattedMessage id={"key_grade_C_option_4"}/>,</li>
                    </ul>
                  </TabPanel>
                  <TabPanel value="4" className={classes.tabPanel}>
                  <ul className={classes.ul}>
                      <li><FormattedMessage id={"key_grade_D_option_1"}/>,</li>
                      <li><FormattedMessage id={"key_grade_D_option_2"}/>,</li>
                      <li><FormattedMessage id={"key_grade_D_option_3"}/>,</li>
                      <li><FormattedMessage id={"key_grade_D_option_4"}/>,</li>
                      <li><FormattedMessage id={"key_grade_D_option_5"}/>,</li>
                    </ul>
                  </TabPanel>
                </TabContext>
              </Box> */}
              </div>
            </div>
          </div>
          {/* {
            cardDetails.slice(0, 2).map(d => {
              console.log(d)
            })
          }
          <div className="col-md-12 col-sm-12 m-4 p-4">



          </div> */}
        </div>
      )}

      <Dialog
        open={modalState}
        keepMounted
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        onClose={() => setModalState(false)}
      >
        <DialogTitle
          id="alert-dialog-slide-title"
          style={{ textAlign: "center" }}
        >
          {selectedGradeProsDesc?.degree || "None"}{" "}
          <FormattedMessage id="grade.card.dialogue.title" />
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-slide-description"
            component="div"
          >
            <div style={{ fontSize: 14, marginBottom: 5 }}>
              <ul>
                {selectedGradeProsDesc?.desc?.length > 0 &&
                  selectedGradeProsDesc?.desc?.map((gradeDesc, index) => {
                    return (
                      <li key={index} style={{ wordBreak: "break-all" }}>
                        <FormattedMessage id={`${gradeDesc.value}`} />
                      </li>
                    );
                  })}
              </ul>
            </div>
          </DialogContentText>
          <DialogActions>
            <Button
              onClick={() => setModalState(false)}
              color="secondary"
              autoFocus
            >
              <FormattedMessage id="button.close" />
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Home;
